/* eslint-disable prefer-destructuring */
import defaultSchema from 'bam-node-evp/src/schema/default.ts'
import clone from 'lodash/clone'
import find from 'lodash/find'

export default function LoadSchema(data, player, options) {
    const schema = clone(defaultSchema)
    schema.chartTypeCategory = ''
    schema.selectedChart = options.selectedChart
    const chart = {
        legend: true,
    }

    const isRHB = find(data, (d) => d.stand === 'R')

    const isLHB = find(data, (d) => d.stand === 'L')
    chart.showRHB = !!isRHB
    chart.showLHB = !!isLHB

    const pitcherPerspective = options.perspective === 'pitcher'
    const normalize = options.normalize === 'normalized'

    if (options.selectedChart.indexOf('pitchChart') > -1) {
        const type = options.selectedChart.split('-')
        chart.chartType = 'pitch'
        chart.overlayType = 'pitch'
        schema.chartType = 'pitch'
        schema.chartTypeCategory = 'pitch'
        chart.strikeZoneFill = 'NONE'
        chart.type = type[1]
        chart.legendType = type[1]
        chart.show = true
        chart.legend = true
        chart.showStrikeZone = true
        chart.showPlate = true
        chart.pitcherPerspective = pitcherPerspective
        chart.normalize = normalize
    } else if (options.selectedChart.indexOf('zoneChart') > -1) {
        const type = options.selectedChart.split('-')
        chart.chartType = 'pitch'
        chart.overlayType = 'zone'
        schema.chartType = 'pitch'
        schema.chartTypeCategory = 'zone'

        chart.showText = true
        chart.type = type[1]
        chart.show = true
        chart.showPlate = true
        chart.pitcherPerspective = pitcherPerspective
    } else if (options.selectedChart.indexOf('hexBinChart') > -1) {
        const type = options.selectedChart.split('-')
        chart.chartType = 'pitch'
        chart.overlayType = 'hexbin'
        schema.chartType = 'pitch'
        schema.chartTypeCategory = 'hexbin'

        chart.type = type[1]
        chart.show = true
        chart.scaleRadius = true
        chart.legend = true
        chart.showStrikeZone = true
        chart.showPlate = true
        chart.pitcherPerspective = pitcherPerspective
        chart.normalize = normalize
    } else if (options.selectedChart.indexOf('pitchPie') > -1) {
        chart.chartType = 'pitch'
        chart.overlayType = 'pie'
        schema.chartType = 'pitch'
        schema.chartTypeCategory = 'pie'

        chart.show = true
        chart.scaleRadius = true
        chart.legend = true
        chart.showStrikeZone = true
        chart.showPlate = true
        chart.pitcherPerspective = pitcherPerspective
        chart.normalize = normalize
    } else if (options.selectedChart.indexOf('pitchContour') > -1) {
        chart.chartType = 'pitch'
        chart.overlayType = 'contour'
        schema.chartType = 'pitch'
        schema.chartTypeCategory = 'contour'

        chart.legend = true
        chart.show = true
        chart.showStrikeZone = true
        chart.showPlate = true
        chart.pitcherPerspective = pitcherPerspective
        chart.normalize = normalize
    } else if (options.selectedChart.indexOf('lineGraphChart') > -1) {
        const type = options.selectedChart.split('-')[1]
        schema.chartType = 'line'

        chart.show = true
        chart.chartType = 'line'
        chart.chartTypeCategory = type[1]
        if (type === 'pitchVelocity') {
            chart.yField = 'releaseSpeed'
            chart.legendType = 'pitchName'
            chart.groupBy = 'pitchName'
            chart.autoFilterBadPoints = true
            chart.unit = 'MPH'
            chart.yDomain = [60, 105]
            chart.yRange = 10
        }
        if (type === 'spinRate') {
            chart.yField = 'releaseSpinRate'
            chart.legendType = 'pitchName'
            chart.groupBy = 'pitchName'
            chart.autoFilterBadPoints = true
            chart.unit = 'RPM'
            chart.yDomain = [0, 3500]
            chart.yRange = 1000
        }
    } else if (options.selectedChart.indexOf('sprayChart') > -1) {
        schema.chartType = 'field'
        schema.chartTypeCategory = 'spray'

        chart.chartType = 'field'
        chart.overlayType = 'spray'
        chart.legend = true
        chart.legendType = 'paResult'
        chart.show = true
    } else if (options.selectedChart.indexOf('sprayHexBin') > -1) {
        const type = options.selectedChart.split('-')
        chart.chartType = 'field'
        chart.overlayType = 'hexbin'
        schema.chartType = 'field'
        schema.chartTypeCategory = 'hexbin'

        chart.type = type[1]
        chart.legend = true
        chart.show = true
        chart.scaleRadius = true
    } else if (options.selectedChart.indexOf('sprayContour') > -1) {
        chart.chartType = 'field'
        chart.overlayType = 'contour'
        schema.chartType = 'field'
        schema.chartTypeCategory = 'contour'

        chart.show = true
        chart.legend = true
    } else if (options.selectedChart.indexOf('3d') > -1) {
        const view = options.selectedChart.split('-')
        schema.chartType = '3d'
        schema.chartTypeCategory = 'spray'

        chart.chartType = '3d'
        chart.legend = true
        chart.legendType = 'paResult'
        chart.overlayType = 'spray'
        chart.view = view[1]
    } else if (options.selectedChart === 'release') {
        schema.chartType = 'release'
        chart.legendType = 'pitchName'
        chart.legend = true
        chart.chartType = 'release'
    } else if (options.selectedChart === 'movement') {
        schema.chartType = 'movement'
        chart.legendType = 'pitchName'
        chart.legend = true
        chart.chartType = 'movement'
    } else if (options.selectedChart.indexOf('z-movement-line') > -1) {
        chart.show = true
        chart.chartType = 'line'
        schema.chartType = 'line'
        chart.yField = 'pfxZGravity'
        chart.legend = true
        chart.legendType = 'pitchName'
        chart.groupBy = 'pitchName'
        chart.autoFilterBadPoints = true
        chart.unit = '"'
        chart.yDomain = [70, 0]
        chart.yRange = 10
    } else if (options.selectedChart.indexOf('x-movement-line') > -1) {
        chart.show = true
        chart.chartType = 'line'
        schema.chartType = 'line'
        chart.yField = 'pfxX'
        chart.legend = true
        chart.legendType = 'pitchName'
        chart.groupBy = 'pitchName'
        chart.autoFilterBadPoints = false
        chart.unit = '"'
        chart.yDomain = [-25, 25]
        chart.yRange = 5
    } else if (options.selectedChart === 'radial') {
        schema.chartType = 'radial'
        chart.chartType = 'radial'
    } else if (options.selectedChart.indexOf('network') > -1) {
        schema.chartType = 'network'
        const view = options.selectedChart.split('-')
        chart.chartType = 'network'
        chart.overlayType = view[1]
        chart.legend = true
        chart.scaleRadius = true
    }

    schema.charts = []
    schema.charts.push(chart)

    if (options.subTitle) {
        schema.namePlate.secondaryTitleText = options.subTitle
        //        schema.namePlate.tertiaryTitleText = options.yearText;
    } else {
        schema.namePlate.secondaryTitleText = ''
        schema.namePlate.tertiaryTitleText = null
    }
    schema.sourcePlate.sourceTitle = 'promo'
    schema.sourcePlate.sourceColor = '#041E42'
    schema.sourcePlate.siteTitle = options.chartName.toUpperCase()
    schema.sourcePlate.siteColor = '#3a9098'

    schema.venueId = options.venueId || 7

    schema.namePlate.primaryTitleText = player.playerName
    schema.namePlate.photoId = player.playerId
    schema.namePlate.teamLogoId = options.teamLogoId || 'primary'

    schema.shape = options.shape || 'square'

    if (window.innerWidth <= 1080 && schema.shape === 'square') {
        const shapeRatio = (window.innerWidth * 0.93) / 500
        schema.shapeRatio = shapeRatio
    } else if (window.innerWidth <= 1080 && schema.shape === 'twitter') {
        const shapeRatio = (window.innerWidth * 0.75) / 500
        schema.shapeRatio = shapeRatio
    } else {
        schema.shapeRatio = 1.2
    }

    return schema
}
